import {cn} from '@sollapay/ui';

import {ACTIVATION_CONTENT_WIDTH} from '../constants';

import type {FC, ReactNode} from 'react';

export interface ActivationCardProps {
  children: ReactNode;
}

/** Shared shell for the activation card — used by both the loading skeleton and the loaded content, so they can never visually drift apart. */
export const ActivationCard: FC<ActivationCardProps> = ({children}) => (
  <section className="flex flex-col items-center gap-6" data-slot="trust-account-activation-page">
    <div
      className={cn(
        'relative w-full overflow-clip rounded-xl border border-border bg-background-surface shadow-xs',
        ACTIVATION_CONTENT_WIDTH
      )}
      data-slot="activation-card"
    >
      {children}
    </div>
  </section>
);
